import { render, staticRenderFns } from "./CardPerson.vue?vue&type=template&id=a161db40&scoped=true"
import script from "./CardPerson.vue?vue&type=script&lang=js"
export * from "./CardPerson.vue?vue&type=script&lang=js"
import style0 from "./CardPerson.vue?vue&type=style&index=0&id=a161db40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161db40",
  null
  
)

export default component.exports